(function () {
    'use strict';
    realmCommerceApp.config(config);

    /*@ngInject*/
    function config(formlyConfigProvider) {

        formlyConfigProvider.setWrapper({
            types: ['input', 'checkbox', 'select', 'textarea', 'radio'],
            template: '<formly-transclude></formly-transclude><div ng-messages="options.formControl.$error" ng-if="options.validation.errorExistsAndShouldBeVisible"><div ng-message="{{ ::name }}" ng-repeat="(name, message) in ::options.validation.messages" ng-if="options.formControl.$error[name]" class="error-messages message">{{ message(fc.$viewValue, fc.$modelValue, this)}}</div></div>',
            overwriteOk: true
        });

        formlyConfigProvider.setWrapper({
            name: 'inlineInputGroupText',
            template: require('../layout/formly/wrappers/inline-input-group-text.html'),
            overwriteOk: true
        });
        formlyConfigProvider.setWrapper({
            name: 'bootstrapLabel',
            template: require('../layout/formly/wrappers/label.html'),
            overwriteOk: true
        });
        formlyConfigProvider.setWrapper({
            name: 'inlineInputGroupSelect',
            template: require('../layout/formly/wrappers/inline-input-group-options.html'),
            overwriteOk: true
        });
        formlyConfigProvider.setWrapper({
            name: 'inlineInputGroupCountry',
            template: require('../layout/formly/wrappers/inline-input-group-country.html'),
        });
        formlyConfigProvider.setWrapper({
            name: 'cartVoucherInput',
            template: require('../layout/formly/wrappers/cart-voucher-input.html')
        });
        formlyConfigProvider.setWrapper({
            name: 'paymentOptionsRadio',
            template: require('../layout/formly/wrappers/payment-options-radio.html')
        });
        formlyConfigProvider.setWrapper({
            name: 'row',
            template: require('../layout/formly/wrappers/row.html')
        });

        formlyConfigProvider.setType({
            name: 'radio',
            template: require('../layout/formly/types/radio.html'),
            overwriteOk: true
        });

        formlyConfigProvider.setType({
            name: 'radio',
            template: require('../layout/formly/types/radio.html'),
            overwriteOk: true
        });

        /*@todo This selectpicker have issues on live server whereits not populating the dropdown*/
        formlyConfigProvider.setType({
            name: 'select',
            template: require('../layout/formly/types/dropdown.html'),
            link: function (scope, el, attrs) {
                /*$(el).find('select').selectpicker({
                    title: (scope.to.nullableDisplay) ? scope.to.nullableDisplay : 'Select'
                });*/
            },
            wrapper: ['bootstrapLabel', 'bootstrapHasError'],
            overwriteOk: true
        });
        formlyConfigProvider.setType({
            name: 'orderTermsCheckbox',
            template: require('../layout/formly/types/order-terms-check.html'),
            link: orderTermsLink
        });
        formlyConfigProvider.setType({
            name: 'ComboDatePicker',
            template: require('../layout/formly/types/combo-date-picker.html'),
            wrapper: ['bootstrapLabel', 'bootstrapHasError'],
            link: function (scope, el) {
                $(el).find('select').selectpicker();
                setTimeout(() => {
                    $(el).find('select').selectpicker('refresh');
                }, 2000);
            }
        });

        formlyConfigProvider.setType({
            name: 'AddressList',
            template: '<shipping-address-list removable="false" selectable="true" selected-address="model[options.key]" ></shipping-address-list>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        });

        formlyConfigProvider.setType({
            name: 'captcha',
            template: '<div vc-recaptcha size="normal" class="scale-captcha" ng-model="model[options.key]" key="options.templateOptions.googleKey"></div>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        });

        function orderTermsLink(scope, elm) {
            var TermElement = elm.find('.thin-border-panel').clone();
            elm.remove();
            TermElement.insertBefore(".orderSubmitBtn");
        }
    }

})();


// WEBPACK FOOTER //
// ./static/js/app/config/formly.config.js